import { Component, OnInit } from '@angular/core';
import { LogisticService, BusinesscoItem, StockplaceItem } from '../../../services/logistic.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { ModalService } from '@app/core/services/modal.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { GetMaterialItemParams } from '@app/views/components/material-item/material-item.component';

@Component({
    selector: 'tt-material-items',
    templateUrl: './material-items.component.html',
    styleUrls: ['./material-items.component.css'],
})
export class MaterialItemsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public grid?: GridOptions;

    public searchTextButtons: FormButton[] = [{ id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadGrid() }];

    constructor(
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private modal: ModalService,
    ) {}

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3954))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_materialitems_grid')
                .setLoadDataFunction({
                    method: 3955,
                    parameters: this.setting,
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .addToolbarButton({
                    name: 'new_material_item',
                    text: 'materialitems_new',
                    icon: 'far fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l',
                    func: () => this.openMaterialItemDialog({ stockbatch_keyno: '0', stockbatch_keyno_copyfrom: '0' }),
                })
                .addRowButton({
                    name: 'new_material_item',
                    icon: 'far fa-pen',
                    btn_type: 'primary',
                    tooltip: 'materialitems_edit',
                    func: (row) => this.openMaterialItemDialog({ stockbatch_keyno: row['stockbatch_keyno'], stockbatch_keyno_copyfrom: '0' }),
                })
                .addRowButton({
                    name: 'copy_material_item',
                    icon: 'far fa-copy',
                    btn_type: 'primary',
                    tooltip: 'materialitems_copyfrom',
                    func: (row) => this.openMaterialItemDialog({ stockbatch_keyno: '0', stockbatch_keyno_copyfrom: row['stockbatch_keyno'] }),
                })
                .addRowButton({
                    name: 'stockbatchlogg',
                    icon: 'far fa-history',
                    btn_type: 'primary',
                    tooltip: 'materialitems_stockbatchlogg',
                    func: (row) => this.modal.openStateDialog({ state: 'stockbatchlogg', params: `stockbatch_keyno/${row['stockbatch_keyno']}` }),
                });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async openMaterialItemDialog(params: GetMaterialItemParams) {
        const response: ErrorMessageResponse = await this.modal.openStateDialog({ state: 'materialitem', params: `${params.stockbatch_keyno}/${params.stockbatch_keyno_copyfrom}` });

        if (response) {
            this.grid?.gridfunc?.read();
        }
    }

    public searchItems() {
        this.loadGrid();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            case 'stockplace_id':
                this.loadGrid();
                break;
            case 'searchtext':
                if (this.setting.searchtext === '') this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStockPlaces();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    searchtext: string;
    show_setting: string;
}
